module.exports = __webpack_public_path__ + "img/99room.6b4a7786.jpeg";